// ScrapboxPost + TelegraphAccount + TelegraphPost i18n fragment
const fragment = {
  vi: {
    // ===== Scrapbox · List =====
    'scrapbox.list.title': 'Bài viết Scrapbox',
    'scrapbox.list.create': 'Tạo bài viết',
    'scrapbox.list.searchLabel': 'Tìm kiếm',
    'scrapbox.list.searchPlaceholder': 'Tìm theo tiêu đề, nội dung',
    'scrapbox.list.projectLabel': 'Project',
    'scrapbox.list.projectPlaceholder': 'Tất cả project',
    'scrapbox.list.statusLabel': 'Trạng thái',
    'scrapbox.list.filter': 'Lọc',
    'scrapbox.list.reset': 'Đặt lại',
    'scrapbox.list.status.all': 'Tất cả trạng thái',
    'scrapbox.list.status.draft': 'Nháp',
    'scrapbox.list.status.published': 'Đã đăng',
    'scrapbox.list.status.failed': 'Lỗi',

    // ===== Scrapbox · Table =====
    'scrapbox.status.published': 'Đã đăng',
    'scrapbox.status.failed': 'Lỗi',
    'scrapbox.status.draft': 'Nháp',
    'scrapbox.table.project': 'Project',
    'scrapbox.table.title': 'Tiêu đề',
    'scrapbox.table.status': 'Trạng thái',
    'scrapbox.table.linkPage': 'Link page',
    'scrapbox.table.copyLink': 'Sao chép link',
    'scrapbox.table.publishedAt': 'Đăng lúc',
    'scrapbox.table.createdAt': 'Tạo lúc',
    'scrapbox.table.action': 'Thao tác',
    'scrapbox.action.openScrapbox': 'Mở trên Scrapbox',
    'scrapbox.action.publishNow': 'Đăng ngay',
    'scrapbox.action.edit': 'Sửa bài viết',
    'scrapbox.action.delete': 'Xoá bài viết',
    'scrapbox.empty.title': 'Chưa có bài viết',
    'scrapbox.empty.desc': 'Tạo bài viết Scrapbox đầu tiên',
    'scrapbox.confirm.delete.title': 'Xoá bài viết?',
    'scrapbox.confirm.delete.desc':
      'Chỉ xoá bài khỏi hệ thống. Page đã đăng trên Scrapbox vẫn tồn tại.',
    'scrapbox.confirm.delete.confirm': 'Xoá',
    'scrapbox.toast.deleted': 'Đã xoá bài viết.',
    'scrapbox.toast.opened': 'Đã mở Scrapbox. Page đang được tự động lưu.',
    'scrapbox.toast.publishError': 'Đăng bài thất bại.',

    // ===== Scrapbox · Form =====
    'scrapbox.form.title.create': 'Tạo bài viết Scrapbox',
    'scrapbox.form.title.edit': 'Sửa bài viết Scrapbox',
    'scrapbox.form.subtitle':
      'Soạn nội dung, bấm "Đăng ngay" để tự động mở Scrapbox và lưu page (yêu cầu đã đăng nhập Scrapbox trên trình duyệt).',
    'scrapbox.form.badge.published': '✓ Đã đăng',
    'scrapbox.form.badge.failed': '⚠ Lỗi',
    'scrapbox.form.badge.draft': '• Nháp',
    'scrapbox.form.syntax.title': 'Cú pháp Scrapbox cơ bản',
    'scrapbox.form.syntax.sampleTitle': 'Tiêu đề',
    'scrapbox.form.syntax.bold': 'in đậm',
    'scrapbox.form.syntax.link': 'link tới page khác',
    'scrapbox.form.syntax.hashtag': 'hashtag',
    'scrapbox.form.syntax.quote': 'trích dẫn',
    'scrapbox.form.syntax.code': 'block code',
    'scrapbox.form.baseUrl': 'URL gốc:',
    'scrapbox.form.preview.titlePlaceholder': 'Tiêu đề bài viết...',
    'scrapbox.form.preview.bodyPlaceholder':
      'Nội dung sẽ hiển thị ở đây với cú pháp Scrapbox raw...',
    'scrapbox.form.step1.title': 'Đăng tới đâu?',
    'scrapbox.form.step1.hint': 'Tên project Scrapbox của bạn (ví dụ: leducanh)',
    'scrapbox.form.projectName': 'Project name',
    'scrapbox.form.titleLabel': 'Tiêu đề',
    'scrapbox.form.titlePlaceholder': 'Tiêu đề bài viết — sẽ trở thành tên page',
    'scrapbox.form.titleError': 'Không được chứa các ký tự / ? # \\',
    'scrapbox.form.titleHint': 'Tiêu đề trùng với page đã tồn tại sẽ nối thêm vào cuối page đó.',
    'scrapbox.form.step2.title': 'Nội dung',
    'scrapbox.form.step2.hint': 'Dùng cú pháp Scrapbox; hỗ trợ hyperlink, tag, code…',
    'scrapbox.form.bodyPlaceholder':
      '[* Mở bài]\nNội dung bài viết...\n\n#scrapbox #note\n\ncode:js\n  console.log("hello")',
    'scrapbox.form.previewLabel': 'Xem trước page',
    'scrapbox.form.footerHint':
      'Lưu nháp: chỉ ghi vào hệ thống. Đăng ngay: mở Scrapbox trong tab mới — page sẽ được auto-save bởi Scrapbox.',
    'scrapbox.form.cancel': 'Huỷ',
    'scrapbox.form.saveChanges': 'Lưu thay đổi',
    'scrapbox.form.saveDraft': 'Lưu nháp',
    'scrapbox.form.publishNow': '🚀 Đăng ngay',
    'scrapbox.form.validate.project': 'Vui lòng nhập project name.',
    'scrapbox.form.validate.title': 'Vui lòng nhập tiêu đề bài viết.',
    'scrapbox.form.validate.invalidTitle': 'Tiêu đề không được chứa các ký tự / ? # \\.',
    'scrapbox.form.validate.bodyTooLong': 'Nội dung vượt quá {max} ký tự.',
    'scrapbox.form.toast.published':
      'Đã mở Scrapbox & lưu trạng thái. Tab Scrapbox đang tự động lưu page.',
    'scrapbox.form.toast.draftSaved': 'Đã lưu nháp.',
    'scrapbox.form.toast.saveError': 'Lưu thất bại.',

    // ===== Telegraph Account · List =====
    'tgraphAcc.list.title': 'Tài khoản Telegraph',
    'tgraphAcc.list.create': 'Tạo tài khoản',
    'tgraphAcc.list.searchLabel': 'Tìm kiếm',
    'tgraphAcc.list.searchPlaceholder': 'Tên ngắn / tác giả',
    'tgraphAcc.list.search': 'Tìm kiếm',
    'tgraphAcc.list.reset': 'Đặt lại',
    'tgraphAcc.table.shortName': 'Short Name',
    'tgraphAcc.table.authorName': 'Author Name',
    'tgraphAcc.table.authorUrl': 'Author URL',
    'tgraphAcc.table.pageCount': 'Số bài',
    'tgraphAcc.table.createdAt': 'Ngày tạo',
    'tgraphAcc.table.action': 'Thao tác',
    'tgraphAcc.action.edit': 'Cập nhật',
    'tgraphAcc.action.delete': 'Xoá',
    'tgraphAcc.empty.title': 'Chưa có tài khoản',
    'tgraphAcc.empty.desc': 'Tạo tài khoản Telegraph đầu tiên để đăng bài viết',
    'tgraphAcc.confirm.delete.title': 'Xoá tài khoản Telegraph?',
    'tgraphAcc.confirm.delete.desc':
      'Tài khoản sẽ bị xoá khỏi hệ thống. Các bài viết đã đăng trên telegra.ph vẫn còn.',
    'tgraphAcc.confirm.delete.confirm': 'Xoá',

    // ===== Telegraph Account · Modal =====
    'tgraphAcc.modal.titleCreate': 'Tạo tài khoản Telegraph mới',
    'tgraphAcc.modal.titleEdit': 'Cập nhật tài khoản Telegraph',
    'tgraphAcc.modal.shortNamePlaceholder': 'Ví dụ: Sandbox',
    'tgraphAcc.modal.shortNameHint': 'Tên ngắn (1-32 ký tự), không hiển thị công khai.',
    'tgraphAcc.modal.authorNamePlaceholder': 'Tên tác giả hiển thị ở bài viết',
    'tgraphAcc.modal.authorUrlPlaceholder': 'https://example.com (tuỳ chọn)',
    'tgraphAcc.modal.cancel': 'Huỷ',
    'tgraphAcc.modal.save': 'Lưu',
    'tgraphAcc.modal.create': 'Tạo',
    'tgraphAcc.form.validate.shortName': 'Vui lòng nhập Short Name.',
    'tgraphAcc.toast.created': 'Tạo tài khoản thành công.',
    'tgraphAcc.toast.updated': 'Cập nhật tài khoản thành công.',
    'tgraphAcc.toast.deleted': 'Đã xoá tài khoản.',
    'tgraphAcc.toast.error': 'Thao tác thất bại.',

    // ===== Telegraph Post · List =====
    'tgraphPost.list.title': 'Bài viết Telegraph',
    'tgraphPost.list.create': 'Tạo bài viết',
    'tgraphPost.list.searchLabel': 'Tìm kiếm',
    'tgraphPost.list.searchPlaceholder': 'Tìm theo tiêu đề',
    'tgraphPost.list.accountLabel': 'Tài khoản',
    'tgraphPost.list.allAccounts': 'Tất cả tài khoản',
    'tgraphPost.list.statusLabel': 'Trạng thái',
    'tgraphPost.list.filter': 'Lọc',
    'tgraphPost.list.reset': 'Đặt lại',
    'tgraphPost.list.status.all': 'Tất cả trạng thái',
    'tgraphPost.list.status.draft': 'Nháp',
    'tgraphPost.list.status.published': 'Đã đăng',
    'tgraphPost.list.status.failed': 'Lỗi',

    // ===== Telegraph Post · Table =====
    'tgraphPost.status.published': 'Đã đăng',
    'tgraphPost.status.failed': 'Lỗi',
    'tgraphPost.status.draft': 'Nháp',
    'tgraphPost.table.title': 'Tiêu đề',
    'tgraphPost.table.status': 'Trạng thái',
    'tgraphPost.table.link': 'Link bài viết',
    'tgraphPost.table.copyLink': 'Sao chép link',
    'tgraphPost.table.views': 'Lượt xem',
    'tgraphPost.table.publishedAt': 'Đăng lúc',
    'tgraphPost.table.createdAt': 'Tạo lúc',
    'tgraphPost.table.action': 'Thao tác',
    'tgraphPost.action.refreshViews': 'Cập nhật lượt xem',
    'tgraphPost.action.edit': 'Sửa',
    'tgraphPost.action.delete': 'Xoá',
    'tgraphPost.empty.title': 'Chưa có bài viết',
    'tgraphPost.empty.desc': 'Tạo bài viết Telegraph đầu tiên',
    'tgraphPost.confirm.delete.title': 'Xoá bài viết?',
    'tgraphPost.confirm.delete.desc':
      'Bản ghi sẽ bị xoá khỏi hệ thống. Telegra.ph không hỗ trợ xoá page qua API — bài đã đăng vẫn truy cập được qua URL.',
    'tgraphPost.confirm.delete.confirm': 'Xoá',
    'tgraphPost.toast.deleted': 'Đã xoá bản ghi.',
    'tgraphPost.toast.viewsUpdated': 'Cập nhật lượt xem',
    'tgraphPost.toast.viewsCount': 'Đã có {count} lượt xem.',
    'tgraphPost.toast.viewsError': 'Không lấy được số lượt xem.',

    // ===== Telegraph Post · Form =====
    'tgraphPost.form.title.create': 'Tạo bài viết Telegraph',
    'tgraphPost.form.title.edit': 'Sửa bài viết Telegraph',
    'tgraphPost.form.subtitle':
      'Soạn nội dung bằng Markdown — preview hiển thị bên phải. Ảnh sẽ được upload trực tiếp lên telegra.ph.',
    'tgraphPost.form.badge.published': '✓ Đã đăng',
    'tgraphPost.form.badge.failed': '⚠ Lỗi',
    'tgraphPost.form.badge.draft': '• Nháp',
    'tgraphPost.form.accountLabel': 'Tài khoản Telegraph',
    'tgraphPost.form.accountPlaceholder': 'Chọn tài khoản',
    'tgraphPost.form.noAccounts': 'Chưa có tài khoản. Hãy tạo trước.',
    'tgraphPost.form.titleLabel': 'Tiêu đề',
    'tgraphPost.form.titlePlaceholder': 'Tiêu đề bài viết',
    'tgraphPost.form.authorNameLabel': 'Author Name (ghi đè)',
    'tgraphPost.form.authorNamePlaceholder': 'Để trống dùng author của tài khoản',
    'tgraphPost.form.authorUrlLabel': 'Author URL (ghi đè)',
    'tgraphPost.form.authorUrlPlaceholder': 'https://example.com (tuỳ chọn)',
    'tgraphPost.form.toolbar.heading': 'Tiêu đề (H3)',
    'tgraphPost.form.toolbar.bold': 'Đậm',
    'tgraphPost.form.toolbar.italic': 'Nghiêng',
    'tgraphPost.form.toolbar.link': 'Link',
    'tgraphPost.form.toolbar.list': 'Danh sách',
    'tgraphPost.form.toolbar.numberedList': 'Danh sách số',
    'tgraphPost.form.toolbar.quote': 'Trích dẫn',
    'tgraphPost.form.toolbar.code': 'Code',
    'tgraphPost.form.insert.heading': 'Tiêu đề',
    'tgraphPost.form.insert.bold': 'in đậm',
    'tgraphPost.form.insert.italic': 'in nghiêng',
    'tgraphPost.form.insert.link': 'văn bản',
    'tgraphPost.form.insert.listItem': 'mục',
    'tgraphPost.form.insert.quote': 'trích dẫn',
    'tgraphPost.form.insert.code': 'code',
    'tgraphPost.form.insertImage': 'Chèn ảnh',
    'tgraphPost.form.contentPlaceholder':
      'Soạn nội dung bằng Markdown:\n\n## Tiêu đề\n\n**Đoạn văn** với *italic* và [link](https://...).\n\n- Bullet 1\n- Bullet 2\n\n![Mô tả ảnh](https://...)\n',
    'tgraphPost.form.previewLabel': 'Xem trước',
    'tgraphPost.form.tagsHint':
      'Telegra.ph chỉ hỗ trợ các thẻ giới hạn: p, h3/h4, b, i, a, img, ul, ol, blockquote, code, pre, hr...',
    'tgraphPost.form.cancel': 'Huỷ',
    'tgraphPost.form.saveChanges': 'Lưu thay đổi',
    'tgraphPost.form.saveDraft': 'Lưu nháp',
    'tgraphPost.form.updatePublished': 'Cập nhật bài đã đăng',
    'tgraphPost.form.publishNow': 'Đăng ngay',
    'tgraphPost.form.currentUrl': 'URL hiện tại:',
    'tgraphPost.form.validate.account': 'Vui lòng chọn tài khoản Telegraph.',
    'tgraphPost.form.validate.title': 'Vui lòng nhập tiêu đề.',
    'tgraphPost.form.validate.emptyContent': 'Nội dung không được rỗng khi đăng bài.',
    'tgraphPost.form.confirm.update.title': 'Cập nhật bài viết đã đăng?',
    'tgraphPost.form.confirm.update.desc':
      'Bài viết trên Telegraph sẽ được ghi đè với nội dung mới (URL giữ nguyên).',
    'tgraphPost.form.confirm.update.confirm': 'Cập nhật',
    'tgraphPost.form.toast.imageOnly': 'Chỉ chấp nhận file ảnh.',
    'tgraphPost.form.toast.imageUploaded': 'Đã upload ảnh vào bài viết.',
    'tgraphPost.form.toast.imageError': 'Upload ảnh thất bại.',
    'tgraphPost.form.toast.published': 'Đăng bài thành công',
    'tgraphPost.form.toast.draftSaved': 'Đã lưu nháp.',
    'tgraphPost.form.toast.error': 'Thao tác thất bại.',
  },
  en: {
    // ===== Scrapbox · List =====
    'scrapbox.list.title': 'Scrapbox Posts',
    'scrapbox.list.create': 'Create post',
    'scrapbox.list.searchLabel': 'Search',
    'scrapbox.list.searchPlaceholder': 'Search by title or content',
    'scrapbox.list.projectLabel': 'Project',
    'scrapbox.list.projectPlaceholder': 'All projects',
    'scrapbox.list.statusLabel': 'Status',
    'scrapbox.list.filter': 'Filter',
    'scrapbox.list.reset': 'Reset',
    'scrapbox.list.status.all': 'All statuses',
    'scrapbox.list.status.draft': 'Draft',
    'scrapbox.list.status.published': 'Published',
    'scrapbox.list.status.failed': 'Failed',

    // ===== Scrapbox · Table =====
    'scrapbox.status.published': 'Published',
    'scrapbox.status.failed': 'Failed',
    'scrapbox.status.draft': 'Draft',
    'scrapbox.table.project': 'Project',
    'scrapbox.table.title': 'Title',
    'scrapbox.table.status': 'Status',
    'scrapbox.table.linkPage': 'Page link',
    'scrapbox.table.copyLink': 'Copy link',
    'scrapbox.table.publishedAt': 'Published at',
    'scrapbox.table.createdAt': 'Created at',
    'scrapbox.table.action': 'Actions',
    'scrapbox.action.openScrapbox': 'Open on Scrapbox',
    'scrapbox.action.publishNow': 'Publish now',
    'scrapbox.action.edit': 'Edit post',
    'scrapbox.action.delete': 'Delete post',
    'scrapbox.empty.title': 'No posts yet',
    'scrapbox.empty.desc': 'Create your first Scrapbox post',
    'scrapbox.confirm.delete.title': 'Delete post?',
    'scrapbox.confirm.delete.desc':
      'Only removes the post from the system. The page already published on Scrapbox remains.',
    'scrapbox.confirm.delete.confirm': 'Delete',
    'scrapbox.toast.deleted': 'Post deleted.',
    'scrapbox.toast.opened': 'Scrapbox opened. The page is being auto-saved.',
    'scrapbox.toast.publishError': 'Failed to publish.',

    // ===== Scrapbox · Form =====
    'scrapbox.form.title.create': 'Create Scrapbox post',
    'scrapbox.form.title.edit': 'Edit Scrapbox post',
    'scrapbox.form.subtitle':
      'Write your content, then click "Publish now" to open Scrapbox and save the page automatically (requires being logged in to Scrapbox in your browser).',
    'scrapbox.form.badge.published': '✓ Published',
    'scrapbox.form.badge.failed': '⚠ Failed',
    'scrapbox.form.badge.draft': '• Draft',
    'scrapbox.form.syntax.title': 'Basic Scrapbox syntax',
    'scrapbox.form.syntax.sampleTitle': 'Title',
    'scrapbox.form.syntax.bold': 'bold',
    'scrapbox.form.syntax.link': 'link to another page',
    'scrapbox.form.syntax.hashtag': 'hashtag',
    'scrapbox.form.syntax.quote': 'quote',
    'scrapbox.form.syntax.code': 'code block',
    'scrapbox.form.baseUrl': 'Base URL:',
    'scrapbox.form.preview.titlePlaceholder': 'Post title...',
    'scrapbox.form.preview.bodyPlaceholder': 'Content will appear here with raw Scrapbox syntax...',
    'scrapbox.form.step1.title': 'Where to publish?',
    'scrapbox.form.step1.hint': 'Your Scrapbox project name (e.g. leducanh)',
    'scrapbox.form.projectName': 'Project name',
    'scrapbox.form.titleLabel': 'Title',
    'scrapbox.form.titlePlaceholder': 'Post title — becomes the page name',
    'scrapbox.form.titleError': 'Cannot contain the characters / ? # \\',
    'scrapbox.form.titleHint':
      'A title matching an existing page will be appended to the end of that page.',
    'scrapbox.form.step2.title': 'Content',
    'scrapbox.form.step2.hint': 'Use Scrapbox syntax; supports hyperlinks, tags, code…',
    'scrapbox.form.bodyPlaceholder':
      '[* Intro]\nPost content...\n\n#scrapbox #note\n\ncode:js\n  console.log("hello")',
    'scrapbox.form.previewLabel': 'Page preview',
    'scrapbox.form.footerHint':
      'Save draft: only writes to the system. Publish now: opens Scrapbox in a new tab — the page is auto-saved by Scrapbox.',
    'scrapbox.form.cancel': 'Cancel',
    'scrapbox.form.saveChanges': 'Save changes',
    'scrapbox.form.saveDraft': 'Save draft',
    'scrapbox.form.publishNow': '🚀 Publish now',
    'scrapbox.form.validate.project': 'Please enter a project name.',
    'scrapbox.form.validate.title': 'Please enter a post title.',
    'scrapbox.form.validate.invalidTitle': 'Title cannot contain the characters / ? # \\.',
    'scrapbox.form.validate.bodyTooLong': 'Content exceeds {max} characters.',
    'scrapbox.form.toast.published':
      'Scrapbox opened & status saved. The Scrapbox tab is auto-saving the page.',
    'scrapbox.form.toast.draftSaved': 'Draft saved.',
    'scrapbox.form.toast.saveError': 'Save failed.',

    // ===== Telegraph Account · List =====
    'tgraphAcc.list.title': 'Telegraph Accounts',
    'tgraphAcc.list.create': 'Create account',
    'tgraphAcc.list.searchLabel': 'Search',
    'tgraphAcc.list.searchPlaceholder': 'Short name / author',
    'tgraphAcc.list.search': 'Search',
    'tgraphAcc.list.reset': 'Reset',
    'tgraphAcc.table.shortName': 'Short Name',
    'tgraphAcc.table.authorName': 'Author Name',
    'tgraphAcc.table.authorUrl': 'Author URL',
    'tgraphAcc.table.pageCount': 'Posts',
    'tgraphAcc.table.createdAt': 'Created',
    'tgraphAcc.table.action': 'Actions',
    'tgraphAcc.action.edit': 'Edit',
    'tgraphAcc.action.delete': 'Delete',
    'tgraphAcc.empty.title': 'No accounts yet',
    'tgraphAcc.empty.desc': 'Create your first Telegraph account to publish posts',
    'tgraphAcc.confirm.delete.title': 'Delete Telegraph account?',
    'tgraphAcc.confirm.delete.desc':
      'The account will be removed from the system. Posts already published on telegra.ph remain.',
    'tgraphAcc.confirm.delete.confirm': 'Delete',

    // ===== Telegraph Account · Modal =====
    'tgraphAcc.modal.titleCreate': 'Create new Telegraph account',
    'tgraphAcc.modal.titleEdit': 'Update Telegraph account',
    'tgraphAcc.modal.shortNamePlaceholder': 'e.g. Sandbox',
    'tgraphAcc.modal.shortNameHint': 'Short name (1-32 chars), not shown publicly.',
    'tgraphAcc.modal.authorNamePlaceholder': 'Author name shown on posts',
    'tgraphAcc.modal.authorUrlPlaceholder': 'https://example.com (optional)',
    'tgraphAcc.modal.cancel': 'Cancel',
    'tgraphAcc.modal.save': 'Save',
    'tgraphAcc.modal.create': 'Create',
    'tgraphAcc.form.validate.shortName': 'Please enter a Short Name.',
    'tgraphAcc.toast.created': 'Account created successfully.',
    'tgraphAcc.toast.updated': 'Account updated successfully.',
    'tgraphAcc.toast.deleted': 'Account deleted.',
    'tgraphAcc.toast.error': 'Operation failed.',

    // ===== Telegraph Post · List =====
    'tgraphPost.list.title': 'Telegraph Posts',
    'tgraphPost.list.create': 'Create post',
    'tgraphPost.list.searchLabel': 'Search',
    'tgraphPost.list.searchPlaceholder': 'Search by title',
    'tgraphPost.list.accountLabel': 'Account',
    'tgraphPost.list.allAccounts': 'All accounts',
    'tgraphPost.list.statusLabel': 'Status',
    'tgraphPost.list.filter': 'Filter',
    'tgraphPost.list.reset': 'Reset',
    'tgraphPost.list.status.all': 'All statuses',
    'tgraphPost.list.status.draft': 'Draft',
    'tgraphPost.list.status.published': 'Published',
    'tgraphPost.list.status.failed': 'Failed',

    // ===== Telegraph Post · Table =====
    'tgraphPost.status.published': 'Published',
    'tgraphPost.status.failed': 'Failed',
    'tgraphPost.status.draft': 'Draft',
    'tgraphPost.table.title': 'Title',
    'tgraphPost.table.status': 'Status',
    'tgraphPost.table.link': 'Post link',
    'tgraphPost.table.copyLink': 'Copy link',
    'tgraphPost.table.views': 'Views',
    'tgraphPost.table.publishedAt': 'Published at',
    'tgraphPost.table.createdAt': 'Created at',
    'tgraphPost.table.action': 'Actions',
    'tgraphPost.action.refreshViews': 'Refresh views',
    'tgraphPost.action.edit': 'Edit',
    'tgraphPost.action.delete': 'Delete',
    'tgraphPost.empty.title': 'No posts yet',
    'tgraphPost.empty.desc': 'Create your first Telegraph post',
    'tgraphPost.confirm.delete.title': 'Delete post?',
    'tgraphPost.confirm.delete.desc':
      'The record will be removed from the system. Telegra.ph does not support deleting pages via API — published posts remain accessible by URL.',
    'tgraphPost.confirm.delete.confirm': 'Delete',
    'tgraphPost.toast.deleted': 'Record deleted.',
    'tgraphPost.toast.viewsUpdated': 'Views refreshed',
    'tgraphPost.toast.viewsCount': 'Now has {count} views.',
    'tgraphPost.toast.viewsError': 'Could not fetch view count.',

    // ===== Telegraph Post · Form =====
    'tgraphPost.form.title.create': 'Create Telegraph post',
    'tgraphPost.form.title.edit': 'Edit Telegraph post',
    'tgraphPost.form.subtitle':
      'Write content in Markdown — the preview shows on the right. Images are uploaded directly to telegra.ph.',
    'tgraphPost.form.badge.published': '✓ Published',
    'tgraphPost.form.badge.failed': '⚠ Failed',
    'tgraphPost.form.badge.draft': '• Draft',
    'tgraphPost.form.accountLabel': 'Telegraph account',
    'tgraphPost.form.accountPlaceholder': 'Select an account',
    'tgraphPost.form.noAccounts': 'No accounts yet. Create one first.',
    'tgraphPost.form.titleLabel': 'Title',
    'tgraphPost.form.titlePlaceholder': 'Post title',
    'tgraphPost.form.authorNameLabel': 'Author Name (override)',
    'tgraphPost.form.authorNamePlaceholder': "Leave empty to use the account's author",
    'tgraphPost.form.authorUrlLabel': 'Author URL (override)',
    'tgraphPost.form.authorUrlPlaceholder': 'https://example.com (optional)',
    'tgraphPost.form.toolbar.heading': 'Heading (H3)',
    'tgraphPost.form.toolbar.bold': 'Bold',
    'tgraphPost.form.toolbar.italic': 'Italic',
    'tgraphPost.form.toolbar.link': 'Link',
    'tgraphPost.form.toolbar.list': 'List',
    'tgraphPost.form.toolbar.numberedList': 'Numbered list',
    'tgraphPost.form.toolbar.quote': 'Quote',
    'tgraphPost.form.toolbar.code': 'Code',
    'tgraphPost.form.insert.heading': 'Heading',
    'tgraphPost.form.insert.bold': 'bold',
    'tgraphPost.form.insert.italic': 'italic',
    'tgraphPost.form.insert.link': 'text',
    'tgraphPost.form.insert.listItem': 'item',
    'tgraphPost.form.insert.quote': 'quote',
    'tgraphPost.form.insert.code': 'code',
    'tgraphPost.form.insertImage': 'Insert image',
    'tgraphPost.form.contentPlaceholder':
      'Write content in Markdown:\n\n## Heading\n\n**Paragraph** with *italic* and [link](https://...).\n\n- Bullet 1\n- Bullet 2\n\n![Image description](https://...)\n',
    'tgraphPost.form.previewLabel': 'Preview',
    'tgraphPost.form.tagsHint':
      'Telegra.ph only supports a limited set of tags: p, h3/h4, b, i, a, img, ul, ol, blockquote, code, pre, hr...',
    'tgraphPost.form.cancel': 'Cancel',
    'tgraphPost.form.saveChanges': 'Save changes',
    'tgraphPost.form.saveDraft': 'Save draft',
    'tgraphPost.form.updatePublished': 'Update published post',
    'tgraphPost.form.publishNow': 'Publish now',
    'tgraphPost.form.currentUrl': 'Current URL:',
    'tgraphPost.form.validate.account': 'Please select a Telegraph account.',
    'tgraphPost.form.validate.title': 'Please enter a title.',
    'tgraphPost.form.validate.emptyContent': 'Content cannot be empty when publishing.',
    'tgraphPost.form.confirm.update.title': 'Update published post?',
    'tgraphPost.form.confirm.update.desc':
      'The post on Telegraph will be overwritten with the new content (URL stays the same).',
    'tgraphPost.form.confirm.update.confirm': 'Update',
    'tgraphPost.form.toast.imageOnly': 'Only image files are accepted.',
    'tgraphPost.form.toast.imageUploaded': 'Image uploaded into the post.',
    'tgraphPost.form.toast.imageError': 'Image upload failed.',
    'tgraphPost.form.toast.published': 'Post published successfully',
    'tgraphPost.form.toast.draftSaved': 'Draft saved.',
    'tgraphPost.form.toast.error': 'Operation failed.',
  },
};

export default fragment;
